import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import useUsers from '../hooks/useUsers';
import placeholderSitePhoto from "../assets/img/placeholder.png";

function Profile() {
    const set = (name, value) => setUser((s) => ({ ...s, [name]: value }));

    const [imgOpen, setImgOpen] = useState(false);
    const [user, setUser] = useState(null);
    // if (loadingS || loadingD || loadingL || loadingDo) {
    //     return <div className="flex flex-1 justify-center items-center"><Loader /></div>;
    // }

    // console.log("lstRdv:",lstRdv);
    // console.log(locations);
    const { fetchUpdateUser } = useUsers();
    const { fetchUserData } = useAuth();

    useEffect(() => {
        async function fetchData() {
            const userInfo = await fetchUserData();

            setUser(userInfo?.user ?? userInfo);
        }
        fetchData();
    }, [fetchUserData]);

    function splitDataUrl(input) {
        const m = /^data:(.*?);base64,(.+)$/i.exec(input || "");
        if (m) {
            return { mime: m[1] || "image/jpeg", base64: m[2] };
        }
        return { mime: null, base64: (input || "").trim() };
    }

    function sanitizeBase64(b64) {
        let s = (b64 || "").trim().replace(/\s+/g, "");
        s = s.replace(/ /g, "+").replace(/%2B/gi, "+");
        const pad = s.length % 4;
        if (pad) s += "=".repeat(4 - pad);
        return s;
    }

    const rawPhoto = user?.b64_ImageUser || user?.Photo;

    const imageSrc =
        rawPhoto && String(rawPhoto).trim()
            ? (String(rawPhoto).startsWith("data:image")
                ? rawPhoto                                   // already data URL
                : `data:image/jpeg;base64,${rawPhoto}`)      // plain base64
            : placeholderSitePhoto;

    const hasRealImage = !!(rawPhoto && String(rawPhoto).trim());

    function readFileAsDataURL(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(file);
        });
    }

    async function handlePickImage(file) {
        if (!file) return;
        if (file.size > 5 * 1024 * 1024) {
            alert("Image trop lourde (>5 Mo).");
            return;
        }
        try {
            const dataUrl = await readFileAsDataURL(file);
            set("b64_ImageUser", dataUrl);
        } catch (e) {
            console.error(e);
            alert("Impossible de lire l’image.");
        }
    }

    const onSave = async () => {
        const payload = {
            ...user,
            b64_ImageUser: user?.b64_ImageUser ? sanitizeBase64(splitDataUrl(user.b64_ImageUser).base64) : "",
            Type_ImageUser: user?.b64_ImageUser ? (splitDataUrl(user?.b64_ImageUser).mime || "image/jpg") : "",

        }

        let result;
        result = await fetchUpdateUser(payload);

    }

    console.log("user", user)
    console.log("imgsrc", imageSrc)
    return (
        <div class="flex-1 p-10">
            <div class="gap-6 grid grid-cols-12">
                <div class="gap-6 grid grid-cols-12 col-span-12 xxl:col-span-9">
                    <div class="col-span-12 mt-8">
                        <h1 class="mb-10 w-full font-bold text-gray-800 text-4xl text-center">Profile</h1>
                    </div>
                </div>
            </div>
            <div class="flex justify-center p-4 px-3 py-10">
                <div class="w-full max-w-md">
                    <div class="bg-white shadow-md mb-4 px-3 py-2 rounded-lg">
                        <div class="block px-2 py-2 font-semibold text-gray-700 text-lg">
                            Item List
                        </div>
                        <div class="flex items-center bg-gray-200 rounded-md">
                            <div class="pl-2">
                                <svg class="fill-current w-6 h-6 text-gray-500" xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24">
                                    <path class="heroicon-ui"
                                        d="M16.32 14.9l5.39 5.4a1 1 0 0 1-1.42 1.4l-5.38-5.38a8 8 0 1 1 1.41-1.41zM10 16a6 6 0 1 0 0-12 6 6 0 0 0 0 12z" />
                                </svg>
                            </div>
                            <input
                                class="bg-gray-200 px-2 py-2 rounded-md focus:outline-none w-full text-gray-700 leading-tight"
                                id="search" type="text" placeholder="Search teams or members" />
                        </div>
                        <div class="py-3 text-sm">
                            <div class="flex justify-start hover:bg-blue-100 my-2 px-2 py-2 rounded-md text-gray-700 hover:text-blue-400 cursor-pointer">
                                <span class="bg-gray-400 m-2 rounded-full w-2 h-2"></span>
                                <div class="flex-grow px-2 font-medium">Tighten Co.</div>
                                <div class="font-normal text-gray-500 text-sm tracking-wide">Team</div>
                            </div>
                            <div class="flex justify-start hover:bg-blue-100 my-2 px-2 py-2 rounded-md text-gray-700 hover:text-blue-400 cursor-pointer">
                                <span class="bg-green-400 m-2 rounded-full w-2 h-2"></span>
                                <div class="flex-grow px-2 font-medium">Taylor Otwell</div>
                                <div class="font-normal text-gray-500 text-sm tracking-wide">Member</div>
                            </div>
                            <div class="flex justify-start hover:bg-blue-100 my-2 px-2 py-2 rounded-md text-gray-700 hover:text-blue-400 cursor-pointer">
                                <span class="bg-gray-400 m-2 rounded-full w-2 h-2"></span>
                                <div class="flex-grow px-2 font-medium">Adam Wathan</div>
                                <div class="font-normal text-gray-500 text-sm tracking-wide">Member</div>
                            </div>
                            <div class="flex justify-start hover:bg-blue-100 my-2 px-2 py-2 rounded-md text-gray-700 hover:text-blue-400 cursor-pointer">
                                <span class="bg-gray-400 m-2 rounded-full w-2 h-2"></span>
                                <div class="flex-grow px-2 font-medium">Duke Street Studio Inc.</div>
                                <div class="font-normal text-gray-500 text-sm tracking-wide">Team</div>
                            </div>
                            <div class="flex justify-start hover:bg-blue-100 my-2 px-2 py-2 rounded-md text-gray-700 hover:text-blue-400 cursor-pointer">
                                <span class="bg-green-400 m-2 rounded-full w-2 h-2"></span>
                                <div class="flex-grow px-2 font-medium">Jeffrey Wey</div>
                                <div class="font-normal text-gray-500 text-sm tracking-wide">Member</div>
                            </div>
                        </div>
                        <div class="block bg-gray-200 -mx-3 -mb-2 px-3 py-2 rounded-b-lg text-sm text-right">
                            <button class="px-4 py-2 font-bold text-gray-500 hover:text-gray-600">
                                Cancel
                            </button>
                            <button class="bg-blue-500 hover:bg-blue-700 px-4 py-2 rounded font-bold text-white">
                                Invite
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="flex">
                <div className="group relative">
                    {/* Bouton carré + dropzone */}
                    <label
                        title={hasRealImage ? "Cliquer pour zoomer, ou remplacer" : "Cliquer pour ajouter une image"}
                        className={[
                            "relative block w-24 h-24 sm:w-28 sm:h-28 rounded-full overflow-hidden",
                            "border border-gray-200 bg-gray-50",
                            "cursor-pointer"
                        ].join(" ")}
                        onClick={(e) => {
                            // si une image existe et que le clic n’est pas sur le petit bouton “zoom”, on ouvre le file picker
                            // (le zoom a son propre bouton ci-dessous)
                        }}
                        onDragOver={(e) => { e.preventDefault(); }}
                        onDrop={async (e) => {
                            e.preventDefault();
                            const f = e.dataTransfer.files?.[0];
                            if (f) await handlePickImage(f);
                        }}
                    >
                        {/* Image, toujours contenue dans le carré */}
                        <img
                            src={imageSrc}
                            alt="Photo du site"
                            className="absolute inset-0 w-full h-full object-contain rounded-full"
                            loading="lazy"
                            onError={(e) => {
                                e.currentTarget.onerror = null;
                                e.currentTarget.src = placeholderSitePhoto;
                            }}
                        />

                        {/* Overlay d’état (au survol) */}
                        <div className="hidden absolute inset-0 group-hover:flex justify-center items-end bg-black/0 hover:bg-black/10 transition">
                            <div className="bg-white/90 mb-1 px-2 py-0.5 rounded-md text-gray-700 text-xs">
                                {hasRealImage ? "Remplacer l’image" : "Ajouter une image"}
                            </div>
                        </div>

                        {/* Input fichier masqué */}
                        <input
                            type="file"
                            accept="image/*"
                            className="hidden"
                            onChange={async (e) => {
                                const f = e.target.files?.[0];
                                if (f) await handlePickImage(f);
                                e.target.value = "";
                            }}
                        />
                    </label>

                    {/* Barre d’actions : Zoom + Supprimer (si image) */}
                    <div className="flex flex-col gap-2 mt-2">
                        <button
                            type="button"
                            disabled={!hasRealImage}
                            onClick={() => setImgOpen(true)}
                            className={`inline-flex items-center justify-center rounded-md border px-2.5 py-1 text-xs
              ${hasRealImage
                                    ? "border-gray-300 text-gray-700 hover:bg-gray-50"
                                    : "border-gray-200 text-gray-300 cursor-not-allowed"
                                }`}
                            title={hasRealImage ? "Agrandir l’image" : "Aucune image à agrandir"}
                        >
                            <i className="mr-1 fa-solid fa-magnifying-glass" /> Zoom
                        </button>

                        {hasRealImage && (
                            <button
                                type="button"
                                onClick={() => {
                                    set("b64_ImageUser", "");
                                    set("Photo", "");           // 👈 important
                                }}
                                className="inline-flex justify-center items-center hover:bg-red-50 px-2.5 py-1 border border-red-300 rounded-md text-red-600 text-xs"
                                title="Supprimer l’image"
                            >
                                <i className="mr-1 fa-solid fa-trash" /> Supprimer
                            </button>

                        )}
                    </div>
                </div>

                <button
                    className=''
                    onClick={() => onSave()}>
                    Sauvegarder
                </button>
            </div>
        </div>

    );
}

export default Profile;
